module.exports = __webpack_public_path__ + "img/icon_map_ljsh_c.857171ad.png";